// extracted by mini-css-extract-plugin
export default {"bottomCTA":"ProjectBottomCTA_bottomCTA__ChYAf"};